import {Controller} from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "body", "icon"];
  static values = {
    open: {type: Boolean, default: false},
  };

  connect() {
    this.update();
  }

  toggle() {
    this.openValue = !this.openValue;
  }

  openValueChanged() {
    this.update();
  }

  update() {
    const isOpen = this.openValue;

    // aria-expanded
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", String(isOpen));
    }

    // body max-height toggle for smooth animation
    if (this.hasBodyTarget) {
      this.bodyTarget.classList.toggle("max-h-0", !isOpen);
      this.bodyTarget.classList.toggle("max-h-full", isOpen);
    }

    // rotate icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180", isOpen);
    }
  }
}
